<template>
  <div class="introduction">
    <ItemOne v-for="(product, i) in products" :tabs="tabs" :key="i" :index="i" :product="product" />
  </div>
</template>

<script>
import { getTabList, getProductList } from '../../services'
import ItemOne from './itemOne'

export default {
  name: 'solution',
  components: {
    ItemOne
  },

  data () {
    return {
      tabs: [],
      products: []
    }
  },

  created () {
    getTabList().then(res => {
      this.tabs = res.data.data.data.children
    })
    getProductList().then(res => {
      this.products = res.data.data.data.children
      const params = this.$router.history.current.params
      if (params.index) {
        setTimeout(() => {
          document.getElementById(`introduction${params.index}`).scrollIntoView({
            behavior: 'smooth'
          })
        })
      }
    })
  },

  watch: {
    '$route': function(route) {
      const params = route.params
      if (params.index) {
        setTimeout(() => {
          document.getElementById(`introduction${params.index}`).scrollIntoView({
            behavior: 'smooth'
          })
        })
      }
    },
  }
}
</script>

<style lang="less">
  .introduction {
    .item {
      padding-top: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &-header {
        &-title {
          color: rgba(34, 34, 34, .1);
          font-size: 15px;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 22.5px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 30px;
          }
        }

        &-name {
          font-size: 24px;
          padding: 4px 0px;
          display: flex;
          align-items: center;
          justify-content: center;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 36px;
            padding: 6px 0px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 48px;
            padding: 8px 0px;
          }

          &-line {
            width: 60px;
            height: 2px;
            background: rgba(34, 34, 34, .1);
            display: inline-block;
            margin: 0px 16px;

            @media (min-width: 1280px) and (max-width: 1680px){
              width: 90px;
              height: 3px;
              margin: 0px 24px;
            }
                  
            @media screen and (min-width: 1920px){
              width: 120px;
              height: 4px;
              margin: 0 32px;
            }
          }
          .bold {
            font-weight: bold;
          }
        }

        &-desc {
          color: #959595;
          font-size: 9px;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 13.5px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 18px;
          }
        }
      }

      &-content {
        margin-top: 20px;

        @media (min-width: 1280px) and (max-width: 1680px){
          margin-top: 30px;
        }
              
        @media screen and (min-width: 1920px){
          margin-top: 40px;
        }
      }
    }
  }
</style>